import { Injectable } from '@angular/core';
import { MenuApi } from './menu.api';
import { UserStoreService } from '@/core/stores/user-store.service';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    constructor(
        private readonly menuApi: MenuApi,
        private readonly userStoreService: UserStoreService
    ) {}

    getMenusByRoleId() {
        const roleId = this.userStoreService.getUser()?.role.roleId || '';
        return this.menuApi.getMenusByRoleId(roleId);
    }

    getMenusForSelect() {
        return this.menuApi.getMenusForSelect();
    }
}
